export default __webpack_public_path__ + "static/media/Terms-Condition.1ca3b099.jpg";